import { render, staticRenderFns } from "./DashboardV2.vue?vue&type=template&id=70335416"
import script from "./DashboardV2.vue?vue&type=script&lang=js"
export * from "./DashboardV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70335416')) {
      api.createRecord('70335416', component.options)
    } else {
      api.reload('70335416', component.options)
    }
    module.hot.accept("./DashboardV2.vue?vue&type=template&id=70335416", function () {
      api.rerender('70335416', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboardviews/DashboardV2.vue"
export default component.exports